import { PieChartType } from "./pie-chart/pie-chart.options";
import { BubbleChartType } from "./bubble-chart/bubble.options";
import { TableChartType } from "./table-chart/table.options";

export class ChartRouterComponent extends HTMLElement {
    private _chartType: string
    private _seriesType: string

    constructor() {
        super()
        // Add default styling to ensure proper sizing
        this.style.display = 'flex'
        this.style.width = '100%'
        this.style.height = '100%'
        this.style.justifyContent = 'center'
    }

    connectedCallback() {
        const chartTypeAttribute = this.attributes.getNamedItem('chart-type')
        const seriesTypeAttribute = this.attributes.getNamedItem('series-Type')

        if (!chartTypeAttribute || !seriesTypeAttribute) {
            throw new Error('missing chart and/or series type attributes')
        }

        this._chartType = chartTypeAttribute.value
        this._seriesType = seriesTypeAttribute.value

        if (this.isPieChart(this._chartType)) {
            this.createPieChart()
        } else if (this.isTableChart(this._chartType)) {
            this.createTableChart()
        } else if (this.isBubbleChart(this._chartType)) {
            this.createBubbleChart()
        } else {
            this.createHistoricalChart()
        }
    }

    private isBubbleChart(chartType: string): boolean {
        return Object.keys(BubbleChartType).some(key => BubbleChartType[key as keyof typeof BubbleChartType] === chartType);
    }

    private isPieChart(chartType: string): boolean {
        return Object.keys(PieChartType).some(key => PieChartType[key as keyof typeof PieChartType] === chartType);
    }

    private isTableChart(chartType: string): boolean {
        return Object.keys(TableChartType).some(key => TableChartType[key as keyof typeof TableChartType] === chartType);
    }

    private createTableChart(): void {
        this.innerHTML = `<tbw-table-chart chart-id="${this._chartType}"></tbw-table-chart>`
    }

    private createPieChart(): void {
        this.innerHTML = `<tbw-pie-chart chart-id="${this._chartType}"></tbw-pie-chart>`
    }

    private createHistoricalChart(): void {
        this.innerHTML = `<tbw-historical-chart chart-type="${this._chartType}" series-type="${this._seriesType}"></tbw-historical-chart>`
    }

    private createBubbleChart(): void {
        this.innerHTML = `<tbw-bubble chart-id="${this._chartType}"></tbw-bubble>`
    }
} 